import { atom } from "recoil"

export const paymentPlanRequiredModalState = atom({
    key: "PaymentPlanRequiredModalState",
    default: {
        visible: false
    }
});
